export const ETRI_GOVO_ID = '2681721440996094985';
export const NHN_TENANT_IDS = ['2131218346506734372', '2128315974080561421', '1387695619080878080'];

export const HDC_TENANT_ID = '2576634261213226769';
export const NEQA_DEV_TENANT_ID = '1778784686253343983';
